import React from 'react';
import { Code2, RefreshCw, FileSearch } from 'lucide-react';
import { servicesData } from '@/data/profile';
import AnimatedSection from './AnimatedSection';

const iconMap = {
  1: Code2,
  2: RefreshCw,
  3: FileSearch
};

const Services = () => {
  return (
    <section id="services" className="py-32 px-4 relative">
      <div className="max-w-7xl mx-auto">
        <AnimatedSection animation="fade-up">
          <div className="text-center mb-20 space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white">Services</h2>
            <p className="text-xl text-[#a0a0a0] max-w-2xl mx-auto">
              Des solutions techniques adaptées à vos besoins
            </p>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const Icon = iconMap[service.id];
            return (
                <AnimatedSection key={service.id} animation="fade-up" delay={index * 150}>
                  <div
                      className="group relative bg-[#1a1a1a] rounded-2xl p-8 transition-all duration-500 hover:-translate-y-2 cursor-pointer h-full overflow-hidden"
                  >
                    <div
                        className="absolute inset-0 rounded-2xl p-[1px] opacity-30 group-hover:opacity-100 transition-opacity duration-500"
                        style={{
                          background: `linear-gradient(135deg, ${service.gradient.includes('0066FF') ? '#0066FF, #7B61FF' : service.gradient.includes('7B61FF') && service.gradient.includes('FF4D8D') ? '#7B61FF, #FF4D8D' : '#00D4FF, #0066FF'})`,
                        }}
                    >
                      <div className="w-full h-full bg-[#1a1a1a] rounded-2xl"></div>
                    </div>

                    <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-500`}></div>

                    <div className="relative z-10 space-y-6">
                      <div className={`w-16 h-16 bg-gradient-to-br ${service.gradient} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-500 shadow-lg`}>
                        <Icon className="w-8 h-8 text-white" />
                      </div>

                      <h3 className="text-2xl font-bold text-white group-hover:text-white transition-colors duration-300">{service.title}</h3>
                      <p className="text-[#a0a0a0] leading-relaxed group-hover:text-[#b5b5b5] transition-colors duration-300">{service.description}</p>
                    </div>
                  </div>
                </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;